export const menuModes = {
    CLOSED: "Closed",
    HALF_OPEN: "HalfOpen",
    FULL_OPEN: "FullOpen",
};

export const menuModeDataAttr = {
    [menuModes.CLOSED]: "closed",
    [menuModes.HALF_OPEN]: "halfOpen",
    [menuModes.FULL_OPEN]: "fullOpen",
};
